import React from "react";
import LoginDisplayCard from "../components/LoginDisplayCard";
import WebsiteHero from "../components/WebsiteHero";

const SignInPage = () => (
    <WebsiteHero>
        <LoginDisplayCard />
    </WebsiteHero>
);

export default SignInPage;